// extracted by mini-css-extract-plugin
module.exports = {"FAQ":"styles_FAQ__QCKtt","categories":"styles_categories__d9Ec9","categoriesWrapper":"styles_categoriesWrapper__TVc3d","wrapper":"styles_wrapper__jFexw"};